const propExists = function(object = {}, prop = '') {
    if (prop.indexOf('.') + 1 === 0) {
        return object.hasOwnProperty(prop);
    }
    let props = prop.split('.');
    if (object.hasOwnProperty(props[0])) {
        return propExists(object[props[0]], props.splice(1, props.length).join('.'))
    }
    return false;
};

export default propExists;




// WEBPACK FOOTER //
// ./src/utils/objects/props.js